import { useQuery } from "@tanstack/react-query";
import i18n from "@/i18n";
import { api } from "@/lib/api";
import { UNPAGINATED_FETCH_SIZE } from "@/lib/paging";

/**
 * One big page, since there have never been more than a handful of seizoenen. No paged sibling:
 * this site has no seizoenen browse screen.
 */
export function useSeizoenen() {
  return useQuery({
    queryKey: ["seizoenen"],
    queryFn: async () => {
      const { data, error } = await api.GET("/api/seizoenen", {
        params: { query: { pageSize: UNPAGINATED_FETCH_SIZE } },
      });
      if (error) throw new Error(i18n.t("common:errors.seizoenen"));
      return data?.items ?? [];
    },
  });
}
